import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  Wrapper,
  KeyboardView,
  Input,
  Card,
  Copy,
  Row
} from "app/NativeComponents/common";
import {
  Header,
  ToggleSwitch,
  PillButton
} from "app/NativeComponents/snippets";

import {
  appRedirect,
  setActiveConversation,
  updateUser
} from "app/NativeActions";

class ConversationSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stop_message:
        props.user && props.user.stop_message ? props.user.stop_message : "",
      auto_skip_trace: props.user.auto_skip_trace
        ? props.user.auto_skip_trace
        : 0
    };
  }

  componentDidMount() {
    this.props.setActiveConversation({ conversation: "conversation_settings" });

    if (this.props.user.team_clearance_level < 2) {
      this.handleBack();
    }
  }

  handleBack() {
    this.props.setActiveConversation({ conversation: null });
    this.props.appRedirect({
      redirect: "goBack",
      payload: { type: "message_engine" }
    });
  }

  checkIfNeedsToSave() {
    if (
      this.state.stop_message !== this.props.user.stop_message ||
      this.state.auto_skip_trace !== this.props.user.auto_skip_trace
    ) {
      return true;
    }

    return false;
  }

  updateSettingsField({ prop, value }) {
    this.setState({
      [prop]: value
    });
  }

  saveSettings() {
    this.props.updateUser({
      token: this.props.token,
      type: "conversation_settings",
      payload: {
        stop_message: this.state.stop_message,
        auto_skip_trace: this.state.auto_skip_trace
      }
    });
  }

  renderSubmitButton() {
    if (this.checkIfNeedsToSave()) {
      return (
        <Row style={{ justifyContent: "flex-end" }}>
          <PillButton
            primary={true}
            onPress={() => {
              this.saveSettings();
            }}
          >
            Update Settings
          </PillButton>
        </Row>
      );
    }
  }

  render() {
    return (
      <Container>
        <Header
          title="Conversation Settings"
          leftButtonIcon={"arrow-back"}
          leftButtonAction={() => this.handleBack()}
          rightButtonIcon={this.checkIfNeedsToSave() ? "check" : ""}
          rightButtonAction={
            this.checkIfNeedsToSave() ? () => this.saveSettings() : () => {}
          }
        />
        <KeyboardView>
          <Card>
            <Wrapper
              style={{
                padding: 15,
                backgroundColor: this.props.colors.background_color,
                borderBottomWidth: 1,
                borderBottomStyle: "solid",
                borderBottomColor: this.props.colors.border_color
              }}
            >
              <Copy>
                Edit your stop message text. This will be sent at the end of
                every first message. You must have the word STOP in it.
              </Copy>
            </Wrapper>
            <Input
              ref={"stop_message"}
              name={"stop_message"}
              placeholder={"Stop Message Text"}
              returnKeyType="done"
              blurOnSubmit={true}
              autoCapitalize="sentences"
              onChange={value => {
                this.updateSettingsField({ prop: "stop_message", value });
              }}
              value={this.state.stop_message}
              type="text"
            />
          </Card>

          <Card>
            <ToggleSwitch
              value={this.state.auto_skip_trace == 1 ? true : false}
              onChange={value => {
                this.updateSettingsField({
                  prop: "auto_skip_trace",
                  value: value == true ? 1 : 0
                });
              }}
              title={"Automatically skip trace new leads?"}
              text={
                "When this is on, you'll automatically skip trace a lead when it is added to your account and be charged accordingly. This will not skip trace leads already in your account."
              }
            />
          </Card>

          {this.renderSubmitButton()}
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, settings, native }) => {
  const { token, user, onboarding } = auth;
  const { colors } = settings;
  const { device, platform, isMobile } = native;
  return {
    token,
    user,
    colors,
    onboarding,
    device,
    platform,
    isMobile
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  setActiveConversation,
  updateUser
})(ConversationSettings);
